let ejs = require('ejs')
import stockInList from 'raw-loader!../views/template/stockInList.ejs'
import stockInDetail from 'raw-loader!../views/template/stockIndetail.ejs'
import stockOutList from 'raw-loader!../views/template/stockOutList.ejs'
import stockOutDetail from 'raw-loader!../views/template/stockOutDetail.ejs'
import productReturn from 'raw-loader!../views/template/productReturn.ejs'
import transferOut from 'raw-loader!../views/template/newTransferout.ejs'
import transferIn from 'raw-loader!../views/template/tranferIn.ejs'

export default {
  exportTransferOut(doc){
   let data = doc
    try {
        let result = ejs.render(transferOut, data)
        return result
    } catch (e) {
        console.error(e)
    }
  },
  exportTransferIn(doc){
    let data = doc
    try {
        let result = ejs.render(transferIn, data)
        return result
    } catch (e) {
        console.error(e)
    }
  },

  exportStockInList(doc) {
    let data = doc
    try {
        let result = ejs.render(stockInList, data)
        return result
    } catch (e) {
        console.error(e)
    }
  },
  exportStockInDetail(doc) {
    let data = doc
    try {
        let result = ejs.render(stockInDetail, data)
        return result
    } catch (e) {
        console.error(e)
    }
  },
  exportStockOutList(doc) {
    let data = doc
    try {
        let result = ejs.render(stockOutList, data)
        return result
    } catch (e) {
        console.error(e)
    }
  },
  exportStockOutDetail(doc) {
    let data = doc
    try {
        let result = ejs.render(stockOutDetail, data)
        return result
    } catch (e) {
        console.error(e)
    }
  },
  exportProductReturn(doc) {
      let data = doc
      try {
          let result = ejs.render(productReturn, data)
          return result
      } catch (e) {
          console.error(e)
    }
  },
};
